import React, {Component, Fragment} from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import InputMask from "react-input-mask";
import Loader from "./Loader";
import Error from "./Error";
import trackEvent from "../../utils/track-event";

export default class BuyInOneClick extends Component {
  static propTypes = {
    buyInOneClick: PropTypes.shape({
      action: PropTypes.string,
      fields: PropTypes.shape({
        email: PropTypes.string,
        phone: PropTypes.string
      })
    }),
    modalIsOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    options: PropTypes.objectOf(PropTypes.string),
    authenticityToken: PropTypes.string
  };
  state = {
    message: ``,
    orderComplete: false,
    loading: false,
    loaded: true,
    mask: ``,
    phone: this.props.buyInOneClick.fields.phone
      ? this.props.buyInOneClick.fields.phone
      : ``
  };
  handleForm = (e) => {
    e.preventDefault();
    const {options} = this.props;
    const data = new FormData(e.target);
    if (options) {
      Object.keys(options).forEach((key) => {
        data.append(`buy_one_click_form[variant][${key}]`, options[key]);
      });
    }
    this.setState({
      loading: true,
      loaded: false
    });
    fetch(e.target.action, {
      method: `POST`,
      body: data,
      credentials: `same-origin`
    })
        .then((res) => {
          if (res.status >= 400) {
            throw new Error(res.statusText);
          }
          return res.json();
        })
        .then((json) => {
          if (json.order) {
            trackEvent({
              category: `store button`,
              action: `buy_in_one_click_order`
            });
            if (!json.order.code) {
              this.setState({
                loading: false,
                loaded: true,
                orderComplete: true
              });
            }
            location.pathname = `/thank_you`;
          } else if (json.errors.email && json.errors.phone_number) {
            this.setState({
              message: `Email и телефон имеют неверные значения`,
              loading: false,
              loaded: true
            });
          } else if (json.errors.email) {
            this.setState({
              message: `Email ${json.errors.email[0]}`,
              loading: false,
              loaded: true
            });
          } else if (json.errors.phone_number) {
            this.setState({
              message: `Телефон ${json.errors.phone_number[0]}`,
              loading: false,
              loaded: true
            });
          }
        })
        .catch(() => {
          this.setState({
            message: `Что-то пошло не так,\nпопробуйте обновить страницу`,
            loading: false,
            loaded: true
          });
        });
  };
  handleChangePhone = (e) => {
    const {value} = e.target;
    if (value.length) {
      if (/[0-9]/.test(value)) {
        if (/^[+7]/.test(value)) {
          this.setState({
            mask: `+9(999)999-9999`,
            phone: value
          });
        } else if (/^8/.test(value)) {
          this.setState({
            mask: `9(999)999-9999`,
            phone: value
          });
        } else if (/^[1-9]/.test(value)) {
          this.setState({
            mask: `+9(999)999-9999`,
            phone: `7${value}`
          });
        } else {
          this.setState({
            mask: ``,
            phone: value
          });
        }
      } else if (!/\+(?=.+\d)/.test(value) && value === `+`) {
        this.setState({
          mask: ``,
          phone: value
        });
      } else if (/\+7(?=.+\d)/.test(value)) {
        this.setState({
          mask: `+9(999)999-9999`,
          phone: value
        });
      } else {
        this.setState({
          mask: ``,
          phone: ``
        });
      }
    } else {
      this.setState({
        mask: ``,
        phone: ``
      });
    }
  };
  render() {
    const {
      modalIsOpen,
      closeModal,
      buyInOneClick,
      productId,
      authenticityToken
    } = this.props;
    const {message, orderComplete, loading, mask, phone} = this.state;
    const form = (
      <>
        <h2 className="react-modal__title text-center">Купить в 1 клик</h2>
        <p>
          Размеры и сроки доставки уточним по телефону в течение 30-60 минут
          после заказа
        </p>
        <form
          action={buyInOneClick.action}
          method="post"
          onSubmit={this.handleForm}
        >
          <input name="utf8" type="hidden" value="✓" />
          <input
            type="hidden"
            name="authenticity_token"
            value={authenticityToken}
          />
          <div className="b-input-field">
            <input
              id="email"
              type="text"
              defaultValue={buyInOneClick.fields.email}
              name="buy_one_click_form[email]"
            />
            <label htmlFor="email" className="active">
              E-mail *
            </label>
          </div>
          <div className="b-input-field">
            <InputMask
              mask={mask}
              type="tel"
              id="phone"
              value={phone}
              onChange={this.handleChangePhone}
              name="buy_one_click_form[phone]"
            />
            <label htmlFor="phone" className="active">
              Телефон *
            </label>
          </div>
          <input
            type="hidden"
            name="product_id"
            id="product_id"
            value={productId}
          />
          <input
            type="hidden"
            name="buy_one_click_form[checkout_info]"
            value="one_click"
          />
          <input
            type="submit"
            name="commit"
            value="Оформить заказ"
            className="b-btn b-btn_success"
          />
          <p className="disclaimer">
            Нажимая оформить заказ, вы соглашаетесь с{` `}
            <a href="/legal">правилами пользования</a> и{` `}
            <a href="/legal">политикой конфиденциальности</a>
          </p>
          {message && <Error message={message} />}
          <span className="close" onClick={closeModal}>
            ×
          </span>
        </form>
      </>
    );
    return (
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        overlayClassName="react-modal-overlay"
        className={`react-modal${loading ? ` react-modal_loading` : ``}`}
      >
        {loading && <Loader />}
        {
          orderComplete
            ? <p className="react-modal__message text-center">Заказ принят, ожидайте звонка!</p>
            : form
        }
      </Modal>
    );
  }
}

Modal.setAppElement(`body`);
